module.exports = __webpack_public_path__ + "media/Images/tpa-faq-add-document-image3-21e7af1b41872e8422c420a27219827d.jpg";